<template>
  <DatatableReportV3
    title="Commissions List"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import JobCommisssionLink from "@/Job/Commissions/JobCommissionsLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "completed_on",
            title: "Completed"
          },
          { data: "job" },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name" },
          { data: "address", orderable: false },
          {
            data: "technician",
            filterName: "technician_id"
          },
          {
            data: "revenue",
            className: "text-right",
            searchable: false
          },
          {
            data: "commission",
            className: "text-right",
            orderable: false,
            searchable: false
          },
          {
            data: "amount",
            className: "text-right",
            footerClassName: "text-right",
            searchable: false
          },
          {
            data: "description",
            orderable: false
          }
        ],
        vueComponents: [
          {
            rootId: "commission-owner-modal-vue",
            component: JobCommisssionLink,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Commissions List" });
  }
};
</script>

<style lang="scss"></style>
